import React from 'react'
import "./Home.css"
import Cards from '../../cards/Cards'



const Home = () => {  
  return (
    <div>
    <section className="landing-container">
      <div className="landing-overlay"></div>
      <div className="landing-content">
        <h1 className="landing-title">
          <span className="black-text">Welcome to</span>{" "}
          <span className="yellow-text">M2C</span>
        </h1>
        <p className="landing-subtext">
          Empowering communities through faith, service, and purpose. <br />
          At M2C International, we’re not just an organization — we’re
          a movement built to inspire change, support growth, and transform
          lives through compassion and leadership.
        </p>
        {/* <div className="landing-buttons">
          <a href='/about'><button className="btn primary">Learn More</button></a>
          <a href='/contact'><button className="btn secondary">Contact Us</button></a>
        </div> */}
      </div>
    </section>
    <Cards />
    </div>
    
    
  )
}

export default Home
